function addReadMoreFunctionality()
{
    var resume = $('.resume_layout');

    if(resume.length > 0)
    {
        resume.each(function()
        {
            var resumeShowMore = $(this).find('.showmore_layout');

            $(this).dotdotdot(
            {
                ellipsis: '...',
                height: getResumeLayoutMaxHeight(resumeShowMore),
                after: resumeShowMore,
                callback: function(isTruncate)
                {
                    if(isTruncate)
                    {
                        $('.resume-mobile-upload-video-time').css('visibility', 'hidden');
                    }

                    resume.css('visibility', 'visible');
                }
            });

            $(document).on('click', '.showmore', function(ev) {

                ev.preventDefault();

                var mainShowmoreContent = $(this).closest('.showmore_main_layout');

                mainShowmoreContent.find('.resume_layout').hide();
                mainShowmoreContent.find('.showmore_layout').hide();
                mainShowmoreContent.find('.morecontent_layout').show();
                mainShowmoreContent.find('.morecontent').show();
                mainShowmoreContent.find('.showless_layout').show();
            });

            $(document).on('click', '.showless', function(ev) {

                ev.preventDefault();

                var mainShowmoreContent = $(this).closest('.showmore_main_layout');

                mainShowmoreContent.find('.morecontent_layout').hide();
                mainShowmoreContent.find('.showless_layout').hide();
                mainShowmoreContent.find('.resume_layout').show();
                mainShowmoreContent.find('.showmore_layout').show();
            });
        });
    }
}

/**
 * Devuelve la altura que se desea que tenga el texto
 * resúmen que se muestra justo antes del enlace 'leer más',
 * en función de la sección en la que se encuentra.
 */
function getResumeLayoutMaxHeight(resumeShowMore)
{
    var maxHeight = 240;

    if(resumeShowMore.closest('.featured-video').length > 0)
    {
        maxHeight = 180;
    }

    return maxHeight;
}
